import { PHONE_NUMBER } from '@/constants/Common'

const performance = {
  myPerformance: 'My Performance',
  wins: 'Wins',
  losses: 'Losses',
  avgPoints: 'Avg Points',
  avgPts: 'Avg Pts',
  avgPartner: 'Avg Partner',
  avgPtr: 'Avg Ptr',
  avgOpponent: 'Avg Opponent',
  win: 'Win',
  loss: 'Loss',
  reject: 'Reject',
  validate: 'Validate',
  validateMatch: 'Validate Match',
  confirmValidateMatch:
    'Are you sure that you would like to validate these scores? If so, the match will be finalized and player ratings will update.',
  matchSourceLeague: `If these scores are not correct, please contact the event director or text ${PHONE_NUMBER} with the correct scores.`,
  deleteMatchConfirm:
    'If you delete this match you will have to start over to enter scores and have it affect your rating',
  halfLife: 'Half-Life',
  avgOpp: 'Avg Opp',
  matchesEmpty: "You haven't played any matches yet!",
  matchesEmptyDes: 'Find some players to play with begin your journey!',
}

export type LocalePerformance = typeof performance

export default performance
